<template>
  <div class="footer-socials__wrapper">
    <div
      v-for="socialIcon in socialIcons"
      :key="socialIcon.icon"
      class="footer-socials__icon-wrapper"
    >
      <a-icon
        :icon="socialIcon.icon"
        :to="socialIcon.link"
        :no-hover="true"
        :original="true"
        :width="30"
        :height="30"
        :aria-label="socialIcon.ariaLabel"
        class="footer-socials__icon"
      />
    </div>
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'

export default {
  name: 'FooterSocials',
  components: { AIcon },
  data() {
    const domain = this.$helper.removeEndingSlashes(this.$env.FM_DOMAIN_URL)

    return {
      socialIcons: [
        {
          icon: ICON.SOCIAL_TWITTER,
          link: 'https://twitter.com/financemagnates/',
          ariaLabel: 'FM Twitter'
        },
        {
          icon: ICON.SOCIAL_TELEGRAM,
          link: 'https://t.me/financemagnatesnews',
          ariaLabel: 'FM Telegram'
        },
        {
          icon: ICON.SOCIAL_YOUTUBE,
          link: 'https://www.youtube.com/channel/UCaMiOoCIu0Lb_bEO_V2kI_g',
          ariaLabel: 'FM Youtube'
        },
        {
          icon: ICON.SOCIAL_FACEBOOK,
          link: 'https://www.facebook.com/financemagnates/',
          ariaLabel: 'FM Facebook'
        },
        {
          icon: ICON.SOCIAL_LINKEDIN,
          link: 'https://www.linkedin.com/company/financemagnates/',
          ariaLabel: 'FM LinkedIn'
        },
        {
          icon: ICON.SOCIAL_RSS,
          link: `${domain}/feed/`,
          ariaLabel: 'FM RSS'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-socials__wrapper {
  display: flex;

  .footer-socials__icon-wrapper {
    width: 30px;
    height: 30px;
    margin-right: 18px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
